export default "__VITE_ASSET__ece56d38__"